// 회사소개
export default [
  {
    path: '/:locale([en/]*)?/newsroom',
    name: 'Newsroom',
    component: () => import('@/views/newsroom/Index'),
    redirect: { name: 'NewsroomReport', query: { page: 1 } },
    meta: {
      sitemap: {
        loc: '/newsroom'
      }
    },
    children: [
      {
        path: 'report',
        name: 'NewsroomReport',
        component: () => import('@/views/newsroom/Report'),
        meta: {
          language: false,
          scroll: true
        }
      },
      {
        path: 'media',
        name: 'NewsroomMedia',
        component: () => import('@/views/newsroom/Media'),
        meta: {
          language: false,
          scroll: true
        }
      },
      {
        path: 'fact',
        name: 'NewsroomFact',
        component: () => import('@/views/newsroom/Fact'),
        meta: {
          language: false,
          scroll: true
        }
      },
      {
        path: 'search',
        name: 'NewsroomSearch',
        component: () => import('@/views/newsroom/Search'),
        meta: {
          language: false,
          scroll: true,
          sitemap: { ignoreRoute: true }
        }
      }
    ]
  },
  {
    path: '/:locale([en/]*)?/report/detail/:newsroomId?',
    name: 'newsroomReportDetail',
    component: () => import('@/views/newsroom/ReportDetail'),
    meta: {
      language: false,
      parent: 'NewsroomReport',
      sitemap: { ignoreRoute: true }
    }
  },
  {
    path: '/:locale([en/]*)?/fact/detail/:newsroomId?',
    name: 'newsroomFactDetail',
    component: () => import('@/views/newsroom/FactDetail'),
    meta: {
      language: false,
      parent: 'NewsroomFact',
      sitemap: { ignoreRoute: true }
    }
  },
]
